import React from 'react'
import { Helmet } from 'react-helmet'

import Layout from '../components/Layout'
import SectionBanner from '../components/SectionBanner'
import { Row, Column, Text, Link, HR, Heading } from '../components/styled'

import carbon from '../static/projects/carbon.png'
import alchemy from '../static/projects/alchemy.png'

import Image from '../components/Image'
import { ContactSection } from '../components/Footer'
import { Hero } from './404'

function Project({ height, link, title, img, description, stars }) {
  return (
    <Column width={['100%', '75%', '32%']} height={height} border={2} mb={5}>
      {img && (
        <Row p={4} pb={0}>
          <Image
            width="100%"
            height={['240px', '240px', '180px']}
            src={img}
            alt={title}
            objectPosition="center"
          />
        </Row>
      )}
      <Row width="100%" height="100%">
        <Column p={4} width="100%" height="100%" mb={[4, 4, 0]}>
          <Link.external href={link} hover={null}>
            <Heading.h3 color="black">{title} ↗</Heading.h3>
          </Link.external>
          <Text.detail mt={2} lineHeight={1.4}>
            {description}
          </Text.detail>

          <Row alignSelf="flex-end" justifySelf="baseline" mt="auto">
            {stars && stars >= 100 ? <Text>{stars} &#9733;</Text> : null}
          </Row>
        </Column>
      </Row>
    </Column>
  )
}

const PROJECTS = [
  {
    id: 'carbon',
    title: 'Carbon',
    description:
      'Carbon is the easiest way to create and share beautiful images of your source code',
    img: carbon,
    link: 'https://github.com/dawnlabs/carbon'
  },
  {
    id: 'alchemy',
    title: 'Alchemy',
    description:
      'Convert and merge images all from the convenience of the menu bar',
    img: alchemy,
    link: 'https://github.com/dawnlabs/alchemy'
  },
  {
    id: 'tacklebox',
    title: 'Tacklebox',
    description:
      'A collection of React UX components and hooks for handling common interactions',
    // TODO
    img:
      'https://images.unsplash.com/photo-1534127594702-7882c204e902?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2550&q=80',
    link: 'https://github.com/dawnlabs/tacklebox'
  }
]

const MEMBER_PROJECTS = [
  {
    title: 'calendarx',
    description: 'The go-to, prescribed, Calendar component for React',
    link: 'https://github.com/mfix22/calendarx',
    stars: 100
  },
  {
    title: 'rexrex',
    description: 'Composable JavaScript regular expressions',
    link: 'https://github.com/mfix22/rexrex'
  },
  {
    title: 'eitherx',
    description: 'The go-to, prescribed, error-boundary component for React',
    link: 'https://github.com/mfix22/eitherx'
  }
]

const OSS = props => {
  const [starmap, setStarmap] = React.useState({})
  React.useEffect(() => {
    fetch('https://api.github.com/orgs/dawnlabs/repos')
      .then(res => res.json())
      .then(list => {
        if (list && list.forEach) {
          let newStarMap = {}
          list.forEach(repo => {
            newStarMap[repo.name] = repo.stargazers_count
          })
          setStarmap(newStarMap)
        }
      })
  }, [])

  return (
    <Layout location={props.location} hasContactSection={false}>
      <Column width="100%" alignItems="center">
        <Helmet>
          <title>Open Source Software — Dawn Labs</title>
        </Helmet>
        <Row
          width="100%"
          flexDirection={['column-reverse', 'row']}
          justifyContent={['flex-end', 'space-between']}
          height={['unset', '46rem']}
          alignItems="center"
          pt={['4.5rem', 'unset']}
          pb={[7, 'unset']}
        >
          <Column
            justifyContent="center"
            width={['100%', '50%', '48%', '38%']}
            maxWidth={['unset', '340px', '360px', 'unset']}
          >
            <Heading.h1 mb={5}>Open Source Software</Heading.h1>
            <Text.subheader width={['100%', '90%']}>
              We invest heavily in open source, both in our own tools and by
              contributing to the community.
            </Text.subheader>
          </Column>
          <Hero />
        </Row>

        <HR />

        <SectionBanner title="Projects We Maintain" />
        <Row
          width="100%"
          alignItems="center"
          justifyContent={['center', 'center', 'space-between']}
          flexWrap="wrap"
          mb={7}
        >
          {PROJECTS.map(props => (
            <Project
              key={props.title}
              {...props}
              stars={starmap[props.id]}
              height="350px"
            />
          ))}
        </Row>
        <SectionBanner title="Personal Projects" />
        <Row
          width="100%"
          alignItems="center"
          justifyContent={['center', 'center', 'space-between']}
          flexWrap="wrap"
          mb={7}
        >
          {MEMBER_PROJECTS.map(props => (
            <Project key={props.title} {...props} height="132px" />
          ))}
        </Row>

        <HR />

        <ContactSection prompt="Need help building your own open source product, library, or design-system?">
          <Link.internal
            to="/contact"
            color="black"
            fontSize={6}
            fontWeight="medium"
          >
            GET IN TOUCH
          </Link.internal>
        </ContactSection>
      </Column>
    </Layout>
  )
}

export default OSS
